module.exports = __webpack_public_path__ + "img/northeast-map.baa7f989.png";